import React, {useMemo, useState} from 'react';
import {Accordion, AccordionDetails, AccordionSummary} from '@material-ui/core';
import {ExpandMore} from '@material-ui/icons';
import {FormattedMessage, useIntl} from 'react-intl';
import {InferenceAppDetails} from '../InferenceAppDetails/InferenceAppDetails';
import AddIcon from '../../../assets/icons/AddIcon';
import {Link} from 'react-router-dom';
import {useSelector} from 'react-redux';
import {RootState} from '../../../store';
import {ApplicationDetails} from '../../../types/project/ApplicationDetails';
import {SinglePageApplication} from '../../../types/project/Application';

type InferenceAppAccordionInfo = {
  singlePageApplications: SinglePageApplication[];
  applicationDetails: ApplicationDetails | undefined;
  projectId: string;
  applicationId: string | undefined;
  fromTest?: boolean;
  deploymentId?: string;
};

const InferenceAppAccordion = ({
  singlePageApplications,
  applicationDetails,
  projectId,
  applicationId,
  deploymentId,
  fromTest = false,
}: InferenceAppAccordionInfo) => {
  const intl = useIntl();
  const [inferenceAccordionExpanded, setInferenceAccordionExpanded] = useState(true);
  const userId = useSelector((state: RootState) => state.user.userId);

  const createLink = useMemo(
    () =>
      fromTest
        ? `/project/${projectId}/inference/${deploymentId}/create`
        : `/project/${projectId}/inference/${applicationId}/deployment/${deploymentId}/configure`,
    [projectId, applicationId, deploymentId, fromTest]
  );

  return (
    <Accordion
      className="prod-deploy-details__accordion"
      expanded={inferenceAccordionExpanded}
      elevation={0}
      onChange={() => setInferenceAccordionExpanded(curr => !curr)}
    >
      <AccordionSummary
        className="prod-deploy-details__accordion__title-container"
        expandIcon={<ExpandMore />}
      >
        <FormattedMessage id={'prodDeployment.inferenceApp'} />
      </AccordionSummary>
      <AccordionDetails className="prod-deploy-details__accordion__details">
        {singlePageApplications && (
          <React.Fragment key="prodDeployment_inferenceApp">
            <div className="prod-deploy-details__inference__container">
              {singlePageApplications.length
                ? singlePageApplications.map((spa, index) => {
                    return (
                      <React.Fragment key={`prodDeployment_inferenceApp_det_${index}`}>
                        <InferenceAppDetails
                          spa={spa}
                          showLinkToEdit={applicationDetails?.ownerId === userId}
                          showActionButtons={true}
                        />
                        {index < (singlePageApplications || []).length - 1 && <hr />}
                      </React.Fragment>
                    );
                  })
                : null}
            </div>
            {applicationDetails?.supportsSinglePageApplications &&
              userId === applicationDetails?.ownerId && (
                <>
                  <Link
                    className="prod-deploy-details__add__inference"
                    key="prodDeployment_inferenceApp_link"
                    to={createLink}
                  >
                    <AddIcon />
                    {intl.formatMessage({
                      id: 'prodDeployment.createInference',
                    })}
                  </Link>
                </>
              )}
          </React.Fragment>
        )}
      </AccordionDetails>
    </Accordion>
  );
};

export default InferenceAppAccordion;
